import { getActiveDepositsAmount, getDepositReturnStateText } from 'utils/deposits'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import React from 'react'
import Item from './Item'

interface DepositsProps {
  deposits?: warehouse.UserDeposit[]
  depositsSummary?: warehouse.UserDepositsSummary
}

const Deposits: React.FC<DepositsProps> = ({ deposits, depositsSummary }) => {
  const { t, lang } = useTranslation('warehouse')

  const activeDeposits = deposits?.filter(({ isRefunded }) => !isRefunded)
  if (!activeDeposits || activeDeposits.length === 0) return null

  const activeAmount = getActiveDepositsAmount(activeDeposits, depositsSummary)

  return <>
    <div className='title'>
      <div>{t('deposits')}</div>
      <div>{t('depositsActive')}: {displayPrice(activeAmount)}</div>
    </div>

    <div className='resignation__list'>
      {activeDeposits.map(deposit => <Item
        key={deposit.id}
        icon='payments'
        title={deposit.name}
        desc={getDepositReturnStateText(deposit, t, lang)}
        extra={deposit.amountFormatted || displayPrice(deposit.amount)}
      />)}
    </div>

    <p className='--center'>{t('depositsSettledSeparately')}</p>
  </>
}

export default Deposits
